import React from 'react'
import { Dropdown, Card, DropdownButton } from 'react-bootstrap'
import Tools from '../../../../../Tools'
import classNames from 'classnames'

const DropdownCard = ({
    title,
    button: Toggle,
    onSelect = (e) => console.log(e),
    items = [],
    btnVariant = "tertiary",
    className = '',
    disabled = true,
}) => {

    const _handleItemClick = (e, id) => {
        e.preventDefault();
        onSelect(id)
    }

    return (
        <div className={classNames("dropdown-card", className)}>
            <Dropdown
                id="dropdown-card"
                onSelect={onSelect}
            >
                <Dropdown.Toggle disabled={disabled} variant={btnVariant}>
                    <Toggle />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Header>{title}</Dropdown.Header>
                    {
                        items.map(item => {
                            const id = Tools.convertToDashCase(item);
                            return (
                                <Dropdown.Item
                                    eventKey={id}
                                    key={id}
                                >{item}</Dropdown.Item>
                            )
                        })
                    }
                </Dropdown.Menu>
            </Dropdown>
        </div>
    )
}

// const CustomToggle = React.forwardRef(({ 
//     children, 
//     onClick 
// }, ref) => (
//     <a
//         href=""
//         ref={ref}
//         onClick={(e) => {
//             e.preventDefault();
//             onClick(e);
//         }}
//     >
//         {children}
//     </a>
// ));

const CustomMenu = React.forwardRef(({
    children,
    title,
    style,
    className,
    'aria-labelledby': labeledBy
}, ref) => {

    return (
        <Card
            ref={ref}
            style={style}
            className={className}
            aria-labelledby={labeledBy}
        >
            <Card.Header>
                <Card.Title>{title}</Card.Title>
            </Card.Header>
            <Card.Body>
                {children}
            </Card.Body>
        </Card>
    );
},
);

export default DropdownCard
